// Servicio para traer prestadores de imágenes, adaptado de prestadoresService.js
import { getPrimerosProximosTurnos } from "../../apiClient/rutes/prestadores";
import { getPrestadores } from "../../apiClient/rutes/catalogos";
import dayjs from "dayjs";
import { obtenerNombreDia } from "../../utils/funcionalidadesStrings";
import { obtenerFotoPrestador } from "../../utils/obtenerFotoPrestador";

export const traerPrestadoresImagenes = async (paciente, horariosPrestadores) => {
  let prestadores = await getPrestadores(paciente.token, paciente.mutual);
  let edad = dayjs(dayjs()).diff(paciente.nacimiento, "year");
  prestadores = prestadores.filter((prestador) => {
    if (prestador.filtroEdad) {
      return prestador.edadDesde <= edad && edad <= prestador.edadHasta;
    } else {
      return true;
    }
  });
  prestadores = await getPrimerosProximosTurnos(paciente.token, prestadores, horariosPrestadores, paciente.mutual);
  return prestadores.map((prestador) => ({
    ...prestador,
    codigo: `${prestador.codigo}-${prestador.mutual}`,
    text: prestador.nombre,
    imageSrc: obtenerFotoPrestador(prestador),
    proximoTurnoFecha: prestador.note,
    note: prestador.note
      ? `Próximo turno: ${obtenerNombreDia(dayjs(prestador.note).format("dddd"))} ${dayjs(prestador.note).format("DD")} de ${dayjs(prestador.note).format("MMMM, YYYY")}`
      : '',
  }));
};
